import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';

const Emails = () => {
	const [ state, dispatch ] = useContext( GlobalContext );
	const { upload } = state;

	return (
		<div className="digital-code-emails">
			<h1>Skicka registreringskoder till deltagarnas e-postadresser</h1>
			<p>Välj på vilket sätt du vill lägga till deltagare.</p>

			<input className="faux-radio-checkbox faux-checkbox" id="uploadEmails" type="checkbox" checked={ true === upload } onChange={ () => {
				dispatch( { type: 'SET_UPLOAD', payload: true } );
			} } />
			<label htmlFor="uploadEmails" className="faux-radio-checkbox-label">
				<div>
					<h2>Lägg till deltagare från Excel-fil</h2>
					<span>Lämpligt vid många deltagare.</span>
				</div>
			</label>

			<input className="faux-radio-checkbox faux-checkbox" id="editEmails" type="checkbox" checked={ false === upload } onChange={ () => {
				dispatch( { type: 'SET_UPLOAD', payload: false } );
			} } />
			<label htmlFor="editEmails" className="faux-radio-checkbox-label">
				<div>
					<h2>Lägg till deltagare manuellt</h2>
					<span>Lämpligt vid få deltagare.</span>
				</div>
			</label>

			<nav className="group-right">
				<a className="button btn-fifthary" onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					dispatch( {
						type: 'SET_STEP',
						payload: 'select',
					} );
				} }>Tillbaka</a>

				<a className={ null === upload ? 'button btn-secondary disabled' : 'button btn-secondary' } onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					if ( null === upload ) {
						return;
					}

					dispatch( {
						type: 'SET_STEP',
						payload: upload ? 'uploadExcel' : 'editEmails',
					} );
				} }>Fortsätt</a>
			</nav>
		</div>
	);
};

export default Emails;
